import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, timeout: 15000 });

const ADMIN_KEY_STORAGE = "gna_admin_key";
export const getAdminKey = () => sessionStorage.getItem(ADMIN_KEY_STORAGE) || "";
export const setAdminKey = (k) => (k ? sessionStorage.setItem(ADMIN_KEY_STORAGE, k) : sessionStorage.removeItem(ADMIN_KEY_STORAGE));
const adminHeaders = () => ({ headers: { "X-Admin-Key": getAdminKey() } });

export const createInquiry = (data) => api.post("/inquiries", data).then((r) => r.data);
export const createReviewRequest = (data) => api.post("/review-requests", data).then((r) => r.data);

export const verifyAdmin = (key) => api.post("/admin/verify", null, { headers: { "X-Admin-Key": key } }).then((r) => r.data);
export const listInquiries = () => api.get("/inquiries", adminHeaders()).then((r) => r.data);
export const listReviewRequests = () => api.get("/review-requests", adminHeaders()).then((r) => r.data);
export const updateInquiryStatus = (id, status) => api.patch(`/inquiries/${id}`, { status }, adminHeaders()).then((r) => r.data);
export const updateReviewStatus = (id, status) => api.patch(`/review-requests/${id}`, { status }, adminHeaders()).then((r) => r.data);

export const errorMessage = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => `${(x.loc || []).slice(-1)[0]}: ${x.msg}`).join(", ");
  if (typeof d === "string") return d;
  return e?.message || "Something went wrong";
};
